// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_API, ADD_API_COLLECTION, API_LIST, EDIT_API, GET_API } from '../../../../common/constant'

export const actionApi = createAsyncThunk('appApi/actionApi', async (params, thunkAPI) => {
    return await post(API_LIST, params, thunkAPI)
})

export const actionGetApi = createAsyncThunk('appApi/actionGetApi', async (params, thunkAPI) => {
    return await post(GET_API, params, thunkAPI)
})

export const actionAddApi = createAsyncThunk('appApi/actionAddApi', async (params, thunkAPI) => {
    return await put(ADD_API, params, thunkAPI)
})

export const actionEditApi = createAsyncThunk('appApi/actionEditApi', async (params, thunkAPI) => {
    return await post(EDIT_API, params, thunkAPI)
})

export const actionAddCollection = createAsyncThunk('appApi/actionAddCollection', async (params, thunkAPI) => {
    return await put(ADD_API_COLLECTION, params, thunkAPI)
})

export const appApiSlice = createSlice({
    name: 'appApi',
    initialState: {
        //list
        loading: false,
        api: null,

        //get
        loadingGet: false,
        getApi: null,

        //add
        loadingAdd: false,
        addApi: null,

        //edit
        loadingEdit: false,
        editApi: null,

        // //add collection
        loadingCollection: false,
        addCollection: null

    },
    reducers: {
        //reset or delete Add API store data

        resetApiResponse: (state) => {
            state.api = null
        },
        resetGetApiResponse: (state) => {
            state.getApi = null
        },
        resetAddApiResponse: (state) => {
            state.addApi = null
        },
        resetEditApiResponse: (state) => {
            state.editApi = null
        },
        resetAddCollectionResponse: (state) => {
            state.addCollection = null
        }
    },
    extraReducers: builder => {
        builder
            //list api
            .addCase(actionApi.pending, (state) => {
                state.loading = true
            })
            .addCase(actionApi.fulfilled, (state, action) => {
                state.loading = false
                state.api = action.payload
            })
            .addCase(actionApi.rejected, (state) => {
                state.loading = false
            })

            // //get api
            .addCase(actionGetApi.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetApi.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getApi = action.payload
            })
            .addCase(actionGetApi.rejected, (state) => {
                state.loadingGet = true
            })

            //add api
            .addCase(actionAddApi.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddApi.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addApi = action.payload
            })
            .addCase(actionAddApi.rejected, (state) => {
                state.loadingAdd = false
            })

            // //edit api
            .addCase(actionEditApi.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditApi.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editApi = action.payload
            })
            .addCase(actionEditApi.rejected, (state) => {
                state.loadingEdit = false
            })

        // //add collection
        .addCase(actionAddCollection.pending, (state) => {
            state.loadingCollection = true
        })
        .addCase(actionAddCollection.fulfilled, (state, action) => {
            state.loadingCollection = false
            state.addCollection = action.payload
        })
        .addCase(actionAddCollection.rejected, (state) => {
            state.loadingCollection = false
        })
    }
})
export const { resetApiResponse, resetAddApiResponse, resetEditApiResponse, resetGetApiResponse, resetAddCollectionResponse } = appApiSlice.actions

export default appApiSlice.reducer